import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@core/core.module';
import { SharedModule } from '@shared/shared.module';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { IConfig, NgxMaskDirective, NgxMaskPipe, provideEnvironmentNgxMask } from 'ngx-mask';

import {
	LoadDetailsFormComponent,
	LoadDetailsFormDialog,
} from './load-details-form/load-details-form.component';
import { LoadDetailsTemplateComponent } from './load-details-template/load-details-template.component';
import { LoadDetailComponent } from './load-detail/load-detail.component';
import { PostLoadComponent, PostLoadDialog } from './post-load/post-load.component';
import { CarrierFilterComponent } from './carrier-filter/carrier-filter.component';
import { MtxPopoverModule } from '@ng-matero/extensions/popover';

const maskConfig: Partial<IConfig> = {};

const imports = [
	CommonModule,
	CoreModule,
	SharedModule,
	NgxMaterialTimepickerModule,
	MtxPopoverModule,
	NgxMaskDirective,
	NgxMaskPipe,
];

const components = [
	LoadDetailsFormComponent,
	LoadDetailsTemplateComponent,
	LoadDetailComponent,
	LoadDetailsFormDialog,
	PostLoadComponent,
	PostLoadDialog,
];

@NgModule({
	declarations: [components, CarrierFilterComponent],
	imports: [imports],
	exports: [...components],
	providers: [provideEnvironmentNgxMask(maskConfig)],
})
export class LoadFormModule {}
